const nullDisplay = '-';

/** Formats nullable text with FAIM's standard missing-value placeholder. */
export function displayText(value: string | null | undefined): string {
  return value == null || value === '' ? nullDisplay : value;
}

/** Formats nullable whole numbers with grouping and no fractional digits. */
export function displayInteger(value: number | null | undefined, locales?: Intl.LocalesArgument): string {
  return value == null ? nullDisplay : new Intl.NumberFormat(locales, { maximumFractionDigits: 0 }).format(value);
}

/** Formats nullable decimal values with FAIM's two-digit precision. */
export function displayDecimal(value: number | null | undefined, locales?: Intl.LocalesArgument): string {
  return value == null ? nullDisplay : new Intl.NumberFormat(locales, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
}

/** Formats nullable ISO dates as locale short dates without a timezone conversion. */
export function displayDate(value: string | null | undefined, locales?: Intl.LocalesArgument): string {
  if (value == null || value === '') return nullDisplay;

  const [year, month, day] = value.slice(0, 10).split('-').map(Number);
  return new Intl.DateTimeFormat(locales).format(new Date(year, month - 1, day));
}

/** Formats boolean values with FAIM's lowercase yes/no labels. */
export function displayBoolean(value: boolean | null | undefined): string {
  return value == null ? nullDisplay : value ? 'yes' : 'no';
}

/** Formats nullable percentages with FAIM's two-digit precision and percent suffix. */
export function displayPercent(value: number | null | undefined, locales?: Intl.LocalesArgument): string {
  return value == null ? nullDisplay : `${displayDecimal(value, locales)}%`;
}

/** Formats nullable coordinates with up to six decimal places and no grouping. */
export function displayCoordinate(value: number | null | undefined): string {
  return value == null ? nullDisplay : value.toFixed(6).replace(/\.?0+$/, '');
}

/** Formats an untyped grid value while ensuring missing values are never blank. */
export function displayGridValue(value: unknown): string {
  if (value == null || value === '') return nullDisplay;
  return String(value);
}